import api from "./Api";

class CfopService {
  GetCfop(payload) {
    return api.get("/v1/cfop/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCfop(payload) {
    return api.post("/v1/cfop/", payload).then((response) => {
      return response.data;
    });
  }

  PutCfop(payload) {
    return api.put("/v1/cfop/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCfop(payload) {
    return api.delete("/v1/cfop/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCfopOData(payload) {
    return api.get("/OData/Cfop" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CfopService();
